import { Route } from '@angular/router';
import {AwardedContractsResolver, AwardedOffersResolver} from '../../resolvers';
import {IsBuyerGuard} from '../../../../auth/routing/guards';
import {AwardedContractsComponent} from "../../../pages/awarded-contracts";

export const AwardedContractsRoutes: Route = {
    path: 'awarded-contracts',
    component: AwardedContractsComponent,
    resolve: {
        //awarded_offers: AwardedOffersResolver
    },
    canActivate: [IsBuyerGuard],
};
